import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about-v4">
      {/* Logo Partnership at Top */}
      <section className="partnership-strip-top">
        <div className="container">
          <div className="partnership-content">
            <div className="logos-row">
              <div className="logo-wrapper">
                <img src="/decode-logo.png" alt="DECODE Logo" className="partner-logo decode-logo-large" />
                <span className="logo-caption">Founder Community</span>
              </div>
              <div className="partnership-connector">
                <div className="connector-line"></div>
                <div className="connector-symbol">×</div>
                <div className="connector-line"></div>
              </div>
              <div className="logo-wrapper">
                <img src="/iovc-logo.avif" alt="IOVC Logo" className="partner-logo" />
                <span className="logo-caption">Investment Fund</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Hero Section Simplified */}
      <section className="hero-simple">
        <div className="hero-background">
          <div className="bg-circle circle-1"></div>
          <div className="bg-circle circle-2"></div>
          <div className="bg-circle circle-3"></div>
        </div>
        <div className="container">
          <div className="hero-content">
            <p className="hero-lead">
              Building the next generation of successful entrepreneurs through
              structured mentorship, proven frameworks, and a global network of founders
              who transform part-time projects into full-time startups.
            </p>
          </div>
        </div>
      </section>


      {/* Story Section - DECODE & Conference Combined */}
      <section className="story-section">
        <div className="container">
          <div className="story-grid">
            <div className="story-content">
              <h2 className="story-title">What is DECODE?</h2>
              <p className="story-text">
                DECODE is the largest founder community with roots from Berkeley and Stanford.
                As a 501(c)3 non-profit, our mission is to help students and alumni transform
                their part-time projects into full-time startups.
              </p>

              {/* Conference Info Integrated */}
              <div className="conference-info-integrated">
                <h3 className="conference-subtitle">Decode Conference 2025</h3>
                <div className="conference-details-inline">
                  <div className="detail-badge">
                    <span className="detail-date">November 15, 2025</span>
                    <span className="detail-location">UC Berkeley</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="story-visual">
              <div className="conference-image-container">
                <img src="/decode-conference.avif" alt="Decode Conference" className="conference-image-main" />
                <div className="conference-overlay">
                  <div className="overlay-content-main">
                    <h4>Decode Conference 2025</h4>
                    <p>UC Berkeley Campus</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Investment Focus */}
      <section className="investment-section">
        <div className="investment-background">
          <div className="bg-dots"></div>
        </div>
        <div className="container">
          <div className="investment-grid">
            <div className="investment-header">
              <div className="investment-content">
                <h2 className="investment-title">IOVC: We invest in fractional founders*</h2>
                <p className="investment-subtitle">
                  *entrepreneurs transforming their part-time projects into full-time startups
                </p>
                <p className="investment-text">
                  We are former founders, now investing in and teaching fractional founders
                  who are building the future of technology and entrepreneurship.
                </p>
              </div>
              <div className="investment-card">
                <div className="card-title">Investment Focus</div>
                <div className="focus-item">
                  <div className="focus-dot"></div>
                  <span>Fractional Founders</span>
                </div>
                <div className="focus-item">
                  <div className="focus-dot"></div>
                  <span>Part-time → Full-time</span>
                </div>
                <div className="focus-item">
                  <div className="focus-dot"></div>
                  <span>Student Entrepreneurs</span>
                </div>
              </div>
            </div>
            <div className="investment-visual">
              <div className="investment-showcase">
                <img src="/iovc-investing-history.avif" alt="IOVC Investment Portfolio" className="portfolio-image" />
                <div className="showcase-overlay">
                  <div className="overlay-text">Investment Portfolio</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Clean CTA */}
      <section className="cta-clean">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title">Ready to Join?</h2>
            <p className="cta-text">
              Be part of the next generation of founders changing the world through technology.
            </p>
            <a href="https://forms.fillout.com/t/hHZE5TwMiuus" target="_blank" rel="noopener noreferrer" className="cta-button">
              Join as a Fellow →
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;